import { useDroppable } from '@dnd-kit/react'
import { useSortable } from '@dnd-kit/react/sortable'
import { CaretRightIcon, DotsSixVerticalIcon, FolderIcon } from '@phosphor-icons/react'
import { useCallback } from 'react'

import { Badge } from '@/components/ui/badge'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'
import type { CommunityEssentialFolderModel } from '@/models'

import * as S from './folder-item.styled'

interface FolderItemProps {
  folder: CommunityEssentialFolderModel
  index: number
  isDropTarget?: boolean
  onNavigate: (folder: CommunityEssentialFolderModel) => void
}

export const FolderItem = ({ folder, index, isDropTarget, onNavigate }: FolderItemProps) => {
  const { ref: sortableRef } = useSortable({ id: `folder-${folder.id}`, index })
  const { ref: droppableRef } = useDroppable({ id: `drop-folder-${folder.id}` })

  const mergedRef = useCallback(
    (element: HTMLDivElement | null) => {
      sortableRef(element)
      droppableRef(element)
    },
    [sortableRef, droppableRef],
  )

  return (
    <S.Row ref={mergedRef} $isDropTarget={isDropTarget} onClick={() => onNavigate(folder)}>
      <S.DragHandle onClick={(e) => e.stopPropagation()}>
        <Icon icon={DotsSixVerticalIcon} size="1.6rem" />
      </S.DragHandle>
      <S.IconWrapper>
        <Icon icon={FolderIcon} size="2rem" />
      </S.IconWrapper>
      <Typography breakLines={1}>{folder.name}</Typography>
      <S.RightSection>
        {folder.essentials && (
          <Badge color="blue" variant="light" size="small">
            {folder.essentials.length}
          </Badge>
        )}
        <Icon icon={CaretRightIcon} size="1.6rem" />
      </S.RightSection>
    </S.Row>
  )
}
